import React from "react";

const AppLayoutWrapper = ({ children }) => {
  return <section className="l-section--m section-pb-0">{children}</section>;
};

export default AppLayoutWrapper;
